import { useTranslation } from 'react-i18next';

import { Empty, Table, TableColumnProps } from '@arco-design/web-react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { EmptyTips } from '../EmptyTips';
import { SectionHeader } from '../SectionHeader';
import i18n from '@/i18n';

export interface EnvItem {
  /** 每个卡片的头部 */
  containerName: string;
  /** 每个卡片的内容,键值对的数组 */
  items: { key: string; value?: string }[];
}

interface DisplayEnvProps {
  items?: EnvItem[];
}

/** 用于展示每个容器中环境变量的配置情况 */
export function EnvTable({ items }: DisplayEnvProps) {
  /** 列 */

  const { t } = useTranslation();
  const columns: TableColumnProps[] = [
    {
      title: t('cluster:key'),
      dataIndex: 'key',
    },
    {
      title: t('common:value'),
      dataIndex: 'value',
    },
  ];

  if (isEmpty(items)) return <Empty />;
  return (
    <ItemLayout>
      {items.map((item, index) => {
        return (
          <EnvItemCard key={index}>
            <SectionHeader
              title={t('common:container.display', { name: item.containerName })}
              titleStyle={{ fontSize: 16, fontWeight: 500 }}
            />
            <Table
              columns={columns}
              data={item.items}
              pagination={false}
              noDataElement={<EmptyTips />}
            />
          </EnvItemCard>
        );
      })}
    </ItemLayout>
  );
}

/** ============================ 样式 ==================================== */
const ItemLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const EnvItemCard = styled.div`
  background-color: #fff;
  padding: 1rem;
`;
